import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { addToCart, toggleFavorite } from '../store/actions/productActions';
import Counter from './Counter';
import { useTheme } from '../context/ThemeContext';
import { getTheme } from '../config/themes';

// HeartIcon винесено ЗА межі класу — щоб React не перестворював тип компонента
// при кожному render(), інакше gradient fill не підхоплюється
function HeartIcon({ filled, gradId, colorFrom, colorTo }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill={filled ? `url(#${gradId})` : 'none'}
      stroke={filled ? colorFrom : 'currentColor'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <defs>
        <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor={colorFrom} />
          <stop offset="100%" stopColor={colorTo} />
        </linearGradient>
      </defs>
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </svg>
  );
}

class Product extends Component {
  constructor(props) {
    super(props);

    const counter = !!this.props.cart[this.props.id];
    const quantity = counter ? this.props.cart[this.props.id].quantity : 0;

    this.state = { counter, quantity, flying: false, nameScrolling: false, tooltipPos: null, showOrgTip: false };

    this.btnRef = createRef();
    this.nameRef = createRef();
    this.addToCart = this.addToCart.bind(this);
    this.changeCounter = this.changeCounter.bind(this);
    this.newQuantity = this.newQuantity.bind(this);
  }

  componentDidMount() {
    this._mounted = true;
    this.checkNameOverflow();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.itemName !== this.props.itemName) {
      this.checkNameOverflow();
    }
  }

  componentWillUnmount() {
    this._mounted = false;
    // Clear any pending timers to prevent setState on unmounted component
    if (this._flyTimer)    clearTimeout(this._flyTimer);
    if (this._shakeTimer)  clearTimeout(this._shakeTimer);
    if (this._orgTimer)    clearTimeout(this._orgTimer);
  }

  checkNameOverflow() {
    const el = this.nameRef.current;
    if (!el) return;
    const inner = el.querySelector('span');
    if (!inner) return;
    const overflow = inner.scrollWidth - el.offsetWidth;
    if (overflow > 0) {
      el.style.setProperty('--marquee-offset', `-${overflow}px`);
      if (this._mounted) this.setState({ nameScrolling: true });
    }
  }

  addToCart(product) {
    this.launchFlyAnimation();
    this.props.addToCart(product);
    if (!this.state.counter) this.setState({ counter: true });
  }

  launchFlyAnimation() {
    const cartBtn = document.querySelector('.cart-btn');
    const btn = this.btnRef.current;
    if (!cartBtn || !btn) return;

    const fromRect = btn.getBoundingClientRect();
    const toRect = cartBtn.getBoundingClientRect();

    const fly = document.createElement('div');
    fly.className = 'fly-to-cart';
    fly.innerHTML = `<svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
      <path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/>
      <line x1="3" y1="6" x2="21" y2="6"/>
      <path d="M16 10a4 4 0 01-8 0"/>
    </svg>`;

    const flyTheme = getTheme(this.props.activeTheme).fly;
    const flyBg = flyTheme.bg;
    const flyShadow = flyTheme.shadow;

    fly.style.cssText = `
      position: fixed;
      left: ${fromRect.left + fromRect.width / 2 - 16}px;
      top: ${fromRect.top + fromRect.height / 2 - 16}px;
      width: 32px; height: 32px;
      background: ${flyBg};
      border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      z-index: 9999;
      pointer-events: none;
      transition: none;
      padding: 6px;
      box-shadow: 0 4px 12px ${flyShadow};
    `;

    document.body.appendChild(fly);

    requestAnimationFrame(() => {
      const dx = toRect.left + toRect.width / 2 - 16 - (fromRect.left + fromRect.width / 2 - 16);
      const dy = toRect.top + toRect.height / 2 - 16 - (fromRect.top + fromRect.height / 2 - 16);

      fly.style.transition = 'transform 650ms cubic-bezier(0.25, 0.46, 0.45, 0.94), opacity 650ms ease';
      fly.style.transform = `translate(${dx}px, ${dy}px) scale(0.4)`;
      fly.style.opacity = '0.9';

      this._flyTimer = setTimeout(() => {
        cartBtn.classList.add('cart-shake');
        fly.remove();
        this._shakeTimer = setTimeout(() => cartBtn.classList.remove('cart-shake'), 600);
      }, 650);
    });
  }

  changeCounter() {
    this.setState({ counter: false });
  }

  newQuantity(quantity) {
    this.setState({ quantity });
  }

  handleToggleFavorite = (e) => {
    e.stopPropagation();
    // Затримка 350ms перед dispatch — щоб анімація CSS встигла відіграти
    // і item у Favorites не мигав при знятті лайку
    const { id, category } = this.props;
    const inFavoritesView = category === 'favorites';

    if (inFavoritesView) {
      // Спочатку CSS-анімація fade-out, потім видалення
      const card = e.currentTarget.closest('.product');
      if (card) {
        card.style.transition = 'opacity 250ms ease, transform 250ms ease';
        card.style.opacity = '0';
        card.style.transform = 'scale(0.95)';
        setTimeout(() => {
          this.props.toggleFavorite(id);
        }, 250);
      } else {
        this.props.toggleFavorite(id);
      }
    } else {
      this.props.toggleFavorite(id);
    }
  }

  render() {
    const { image, itemName, name, price, id, quantity_type, quantity_single, weight, fromCart, favorites, organic } = this.props;
    const displayName = itemName || name || '';
    const sizeName = this.props.sizeName || '';

    const product = { image, name: displayName, price, id, quantity_type, quantity_single, weight, organic: this.props.organic };
    const isFavorite = favorites.includes(String(id));

    const kgValue = weight ? weight : null;
    const lbValue = kgValue
      ? kgValue >= 1
        ? Math.round(kgValue * 2.20462)
        : Math.round(kgValue * 2.20462 * 10) / 10
      : null;

    // activeTheme може бути undefined при першому рендері — підстрахуємось
    const theme = this.props.activeTheme || 'default';
    const grad = getTheme(theme).heart;
    const gradId = `hg-${theme}-${id}`;

    const favBtn = (
      <button
        className={`product-fav-btn${isFavorite ? ' active' : ''}`}
        onClick={this.handleToggleFavorite}
        aria-label={isFavorite ? `Remove ${displayName} from favorites` : `Add ${displayName} to favorites`}
        title={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
      >
        <HeartIcon
          filled={isFavorite}
          gradId={gradId}
          colorFrom={grad.from}
          colorTo={grad.to}
        />
      </button>
    );

    const button = (
      <div className="product-footer">
        {favBtn}
        <button
          ref={this.btnRef}
          type="button"
          className="product-add-btn"
          aria-label={`Add ${displayName} to cart`}
          onClick={() => this.addToCart(product)}
        >
          ADD TO CART
        </button>
      </div>
    );

    const counter = (
      <div className="product-footer">
        <Counter
          product={product}
          fromCart={fromCart}
          changeCounter={this.changeCounter}
          newQuantity={this.newQuantity}
        />
      </div>
    );

    return (
      <div className={this.state.counter ? 'product active' : 'product'}>
        <div
          className="product-image"
          style={{ position: 'relative' }}
          onMouseMove={image ? (e) => {
            const TW = 192, TH = 192, OFFSET = 14;
            const vw = window.innerWidth, vh = window.innerHeight;
            let x = e.clientX + OFFSET;
            let y = e.clientY + OFFSET;
            // flip left if overflows right
            if (x + TW > vw - 8) x = e.clientX - TW - OFFSET;
            // flip up if overflows bottom
            if (y + TH > vh - 8) y = e.clientY - TH - OFFSET;
            // clamp to viewport
            x = Math.max(8, x);
            y = Math.max(8, y);
            this.setState({ tooltipPos: { x, y } });
          } : undefined}
          onMouseLeave={image ? () => this.setState({ tooltipPos: null }) : undefined}
        >
          {image ? (
            <picture>
              <source
                srcSet={image.replace(/\.(jpg|jpeg|png)$/i, '.webp')}
                type="image/webp"
              />
              <img
                src={image}
                srcSet={`${image} 200w, ${image} 400w`}
                sizes="(max-width: 480px) 180px, 200px"
                alt={displayName ? `${displayName}${lbValue ? ` ${lbValue} LB` : sizeName ? ` ${sizeName}` : ''}` : 'Product image'}
                loading="lazy"
                decoding="async"
                style={{width:"100%",height:"100%",objectFit:"contain"}}
              />
            </picture>
          ) : (
            <img
              src={image}
              srcSet={`${image} 200w, ${image} 400w`}
              sizes="(max-width: 480px) 180px, 200px"
              alt={displayName ? `${displayName}${lbValue ? ` ${lbValue} LB` : sizeName ? ` ${sizeName}` : ''}` : 'Product image'}
              loading="lazy"
              decoding="async"
              style={{width:"100%",height:"100%",objectFit:"contain"}}
            />
          )}
          {image && this.state.tooltipPos && (
            <div
              className="product-img-tooltip"
              style={{ left: this.state.tooltipPos.x, top: this.state.tooltipPos.y }}
            >
              <img src={image} alt={displayName} loading="lazy" decoding="async" style={{maxWidth:"200px",maxHeight:"200px",objectFit:"contain"}} />
              <span className="product-img-tooltip__name">{displayName}</span>
            </div>
          )}
          {organic && (
            <div
              className={`product-organic-badge${this.state.showOrgTip ? ' show-tip' : ''}`}
              title="Can be organic"
              onClick={(e) => {
                e.stopPropagation();
                if (this._orgTimer) clearTimeout(this._orgTimer);
                this.setState({ showOrgTip: true });
                this._orgTimer = setTimeout(() => {
                  if (this._mounted) this.setState({ showOrgTip: false });
                }, 2000);
              }}
            >
              🌿
            </div>
          )}
        </div>
        {organic && this.state.showOrgTip && (
          <span className="product-organic-tooltip">Can be organic</span>
        )}
        <div className="product-info">
          <div className="product-name-row">
            <h3
              ref={this.nameRef}
              className={`product-name${this.state.nameScrolling ? ' scrolling' : ''}`}
            >
              <span>{displayName.toUpperCase()}</span>
            </h3>
            {lbValue && <span className="product-unit product-unit--lb">{lbValue} LB</span>}
          </div>
          {(sizeName || kgValue) && (
            <div className="product-name-row product-size-row">
              <span className="product-size">{sizeName ? sizeName.toUpperCase() : ''}</span>
              {kgValue && <span className="product-unit product-unit--kg">{Math.round(kgValue * 10) / 10} KG</span>}
            </div>
          )}
        </div>
        {this.state.counter ? counter : button}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  cart: state.cart,
  favorites: state.favorites,
  category: state.category,
});

const ConnectedProduct = connect(mapStateToProps, { addToCart, toggleFavorite })(Product);

const ProductWithTheme = (props) => {
  const { theme } = useTheme();
  return <ConnectedProduct {...props} activeTheme={theme} />;
};

export default ProductWithTheme;
